export class UserToken {
    constructor(token) {
        if (!token) { token = {}; }
        this.accessToken = token.accessToken;
        this.expiration = token.expiration;
        this.refreshToken = token.refreshToken;
    }
}